import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bolao_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    // Não remove o token automaticamente aqui
    // O contexto de autenticação é responsável por gerenciar o token
    return Promise.reject(error);
  }
);

export function formatarErroApi(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Erro desconhecido";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => e?.msg || JSON.stringify(e)).join(" | ");
  return JSON.stringify(detail);
}
